import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from 'styles/globalStyles';
import { STRINGS } from 'config';
import 'assets/fonts/fonts.css';
import { setProduct } from 'redux/actions/consultation';
import { primaryCareTheme, newExperiencePrimaryCareTheme, eTriageTheme } from './styles/theme';
import { PrimaryCareContainer } from './components/primaryCare';
import { ETriageContainer } from './components/eTriage';

const { FORCE_NHS_LOGIN } = STRINGS.CUSTOMISATION_FLAG_NAMES;

function App(props) {
  const {
    treatmentCategoryCodeName,
    isClinicalReviewMode,
    newExperienceEnabled,
    federatedLoginProvider,
    logInStatus,
    testCode,
    practice,
    encounterId,
    healthAlertUrl,
    product,
    patient,
    twoWayMessageId,
    customisationFlags,
    showNavBar,
    backNav,
    currentQuestionId,
  } = props;
  const mapState = useCallback(state => ({ productInState: state.consultationReducer.product }), []);
  const { productInState } = useMappedState(mapState);
  const [theme] = useState(() => {
    if (product === STRINGS.PRODUCT.E_TRIAGE) {
      return eTriageTheme;
    }
    if (newExperienceEnabled) {
      return newExperiencePrimaryCareTheme;
    }
    return primaryCareTheme;
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (productInState !== product) {
      dispatch(setProduct(product));
    }
  }, [dispatch, product, productInState]);

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyle />
        {product === STRINGS.PRODUCT.E_TRIAGE ? (
          <ETriageContainer
            treatmentCategoryCodeNameAsProps={treatmentCategoryCodeName}
            isClinicalReviewModeAsProps={isClinicalReviewMode}
            forceNhsLoginModeAsProps={customisationFlags?.includes(FORCE_NHS_LOGIN)}
            practiceAsProps={practice}
            product={product}
            patientAsProps={patient}
            showNavBar={showNavBar}
            backNav={backNav}
            currentQuestionId={currentQuestionId}
          />
        ) : (
          <PrimaryCareContainer
            treatmentCategoryCodeNameAsProps={treatmentCategoryCodeName}
            isClinicalReviewModeAsProps={isClinicalReviewMode}
            federatedLoginProviderAsProps={federatedLoginProvider}
            logInStatusAsProps={logInStatus}
            forceNhsLoginModeAsProps={customisationFlags?.includes(FORCE_NHS_LOGIN)}
            testCodeAsProps={testCode}
            practiceAsProps={practice}
            encounterIdAsProps={encounterId}
            healthAlertUrlAsProps={healthAlertUrl}
            product={product}
            twoWayMessageId={twoWayMessageId}
          />
        )}
      </>
    </ThemeProvider>
  );
}

export default App;
